import * as React from 'react';
import { AvatarColour } from '../../../../models';
import './style.css';

export interface AvatarColourPickerProps {
  colour?: string;
  onSave: (colour: AvatarColour) => void;
}

export interface AvatarColourPickerState {
  /* empty */
}

export class AvatarColourPicker extends React.Component<
  AvatarColourPickerProps,
  AvatarColourPickerState
> {
  render() {
    const { colour, onSave } = this.props;
    const avatarColours: Array<{
      colour: string;
      value: AvatarColour;
    }> = Object.keys(AvatarColour).map(key => ({
      colour: key,
      value: AvatarColour[key] as AvatarColour
    }));

    return (
      <div className="avatar-colour-picker">
        {avatarColours.map((avatarColour, index) => (
          <button
            key={index}
            className={`avatar-colour-picker-button${
              avatarColour.value === colour
                ? ' avatar-colour-picker-active-colour'
                : ''
            }`}
            style={{
              background: avatarColour.value
            }}
            type="button"
            onClick={() => onSave(avatarColour.value)}
          />
        ))}
      </div>
    );
  }
}

export default AvatarColourPicker;



// WEBPACK FOOTER //
// ./src/app/components/UserProfile/AvatarEditor/AvatarColourPicker/index.tsx